// Coach escalation — pure rung math for the reading-aware highway feed.
// A leaf module (no engine imports) so coach.ts and coach-driver.ts share it.
// The crutch feeds back in along the SAME discrete ladder the reading tutor
// fades along (songs/reading.ts suggestedHighwayOpacity), so the two can never
// disagree. See docs/superpowers/specs/2026-06-17-coach-escalation-ladder-design.md.

/** The shared reading-fade ladder (1 = full crutch, 0 = read unaided). */
export const READING_RUNGS = [0, 0.33, 0.66, 1] as const;

/** Rungs from the piece baseline up to full = how many stuck-reps the feed spans.
 *  0 when the baseline is full (non-reading) or off-ladder (defensive). */
export function feedDepth(baseline: number): number {
  const i = READING_RUNGS.indexOf(baseline as (typeof READING_RUNGS)[number]);
  return i < 0 ? 0 : READING_RUNGS.length - 1 - i;
}

/** Opacity after advancing `stuckReps` rungs up from `baseline`, capped at full.
 *  An off-ladder baseline is returned unchanged (no feed). */
export function effectiveOpacity(baseline: number, stuckReps: number): number {
  const i = READING_RUNGS.indexOf(baseline as (typeof READING_RUNGS)[number]);
  if (i < 0) return baseline;
  const rung = READING_RUNGS[Math.min(READING_RUNGS.length - 1, i + Math.max(0, stuckReps))];
  return rung ?? 1; // index is always in range; `?? 1` only satisfies strict indexing
}
